<template>
    <div v-if="$store.state.openid != ''">
        <top-bar>
            <div class="title">
                  内荐奖励
            </div>
        </top-bar>
        <van-form @submit="onSubmit">
            <van-field
                v-model="username"
                name="name"
                label="被推荐人姓名"
                placeholder="填写被推荐人姓名"
                :rules="[{ required: true, message: '填写被推荐人姓名' }]"
            />
            <van-field
                v-model="phone"
                name="phone"
                label="被推荐人电话"
                maxlength="11"
                @blur="checkPhone"
                placeholder="填写被推荐人电话"
                :error-message="errMsg"
                :rules="[{ required: true, message: '填写被推荐人电话' }]"
            >
            </van-field>
            <van-field
                v-model="position"
                name="position"
                label="期望的职位"
                placeholder="填写期望的职位"
                :rules="[{ required: true, message: '填写期望的职位' }]"
            />
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">我要内荐</van-button>
            </div>
        </van-form>
        <van-dialog v-model="show" title="提示" @confirm="confirm">
            <div class="cont">点击进行实名验证</div>
        </van-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import TopBar from "@/components/Top";
import { Form,Field,Button,Toast } from "vant";
import { isPhone } from '@/common/common'
import { init,GetQueryString } from '@/utils/getOpenId'
import { getOpenId,httpAction } from "@/http/salary";

Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Toast);

export default {
    data() {
        return {
            username: "",
            phone: "",
            position:'',
            errMsg:'',
            openid:'',
            show: false,
        };
    },
    components:{ TopBar },
    created() {
        this.$cookies.set('history','reward',60 * 60 * 1)
        if(this.$store.state.openid == ''){
            let openid = this.$route.query.openId
            this.$store.dispatch('SAVEUSERACTION',openid)
        }

        // if(this.$store.state.openid == ''){
        //     this.$cookies.set('history','reward',60 * 60 * 1)
        //     let url = encodeURI('http://testwx-platform.engma.net/#/reward')
        //     window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx815dbde2374f3068&response_type=code&scope=snsapi_base&redirect_uri=${url}&state=reward#wechat_redirect`
        // }else{
        //     this.openid =  this.init()
        // }
    },
    methods: {
        async init(){
            let _this = this
            const res = await getOpenId("/wxAuth/codeToOpenid",{code:GetQueryString('code')});
            if(res.msg == 'success'){
                _this.$store.dispatch('SAVEUSERACTION',res.data)
                return res.data
            }
        },
        onSubmit(values) {
            httpAction('post','/weixin/recommend/add',values).then((res) => {
                if(res.success){
                    Toast.success('提交成功')
                    this.phone = ''
                    this.username = ''
                    this.position = ''
                }else if(res.msg == '您还没有实名认证'){
                    this.show = true
                }else{
                    Toast.fail('提交失败,请联系管理员')
                }
            })
        },
        checkPhone(){
            if(this.phone){
                if(!isPhone(this.phone)){
                    Toast.fail('手机号错误')
                    this.phone = ''
                }
            }
        },
        confirm(){
            this.$cookies.set('history','reward',60 * 60 * 1)
            this.$router.push('./Certification')
        }
    },
};
</script>

<style lang="less" scoped>
.title {
    width: 100%;
    height: 100%;
    display: flex;
    font-weight: 700;
    align-items: center;
    justify-content: center;
}
.cont{
    text-align: center;
    padding: 20px;
}
</style>